import { useQuery } from '@apollo/react-hooks';
import { loader } from 'graphql.macro';
import { isMissing } from 'Shared/utils';
import { GrantsType } from 'Shared/utils/auth';

export const GET_RESOURCE_EFFECTIVE_GRANTS = loader(
  './getResourceEffectiveGrantsQuery.graphql'
);

export const useResourceEffectiveGrants = (
  resourceId: string,
  resourceType: string = 'policy'
) => {
  const { error, loading, data } = useQuery<{
    resourceEffectiveGrants: GrantsType;
  }>(GET_RESOURCE_EFFECTIVE_GRANTS, {
    errorPolicy: 'ignore',
    variables: {
      resourceId,
      resourceType,
    },
    skip: isMissing(resourceId),
    fetchPolicy: 'network-only',
  });

  return {
    error,
    loading,
    resourceEffectiveGrants: data?.resourceEffectiveGrants || [],
  };
};
